export default __webpack_public_path__ + "static/media/blueArrowDown.f683ea50.svg";